import moment from "moment";

export const iso8601 = "YYYY-MM-DD";
export const AmericanDateFormat = "M/DD/YYYY hh:mma z";

export const maxBirthDate = () =>
  moment()
    .subtract(18, "years")
    .format(iso8601);

export const maxBirthDateYear = () =>
  parseInt(
    moment()
      .subtract(18, "years")
      .format("YYYY"),
  );

export const maxDOB = moment(maxBirthDate(), iso8601);
export const validDateOfBirth = dateString => {
  if (!dateString.length) return false;

  const dob = moment(dateString, iso8601);
  if (!dob.isValid()) return false;

  return dob.isBefore(maxDOB);
};
